package ru.malygin

import kotlin.String

public object CryptoUtils {
  public fun decrypt(input: String, keyWord: String): String {
    val shift = keyWord.sumOf { it.code }.mod(26) // Calculate shift using .mod
    return input.map { char ->
        when (char) {
            in 'A'..'Z' -> ('Z' - (('Z'.code - char.code + shift).mod(26))).toChar()
            in 'a'..'z' -> ('z' - (('z'.code - char.code + shift).mod(26))).toChar()
            else -> char
        }
    }.joinToString("")
  }
}
